import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { ApiResponse } from "@/lib/api/types";
import type { LoginCredentials, RegisterData, AuthTokens, User } from "@/types/auth";

const BASE = "/auth";

export const authApi = {
  login: (credentials: LoginCredentials) =>
    apiPost<{ user: User; tokens: AuthTokens }>(`${BASE}/login`, credentials),

  register: (data: RegisterData) =>
    apiPost<{ user: User; tokens: AuthTokens }>(`${BASE}/register`, data),

  logout: () => apiPost<{ message: string }>(`${BASE}/logout`),

  refresh: (refreshToken: string) =>
    apiPost<{ accessToken: string; refreshToken: string; expiresIn: number }>(`${BASE}/refresh`, { refreshToken }),

  getMe: () => apiGet<{ user: User }>(`/users/me`),

  updateProfile: (data: Partial<User>) =>
    apiPut<{ user: User }>(`/users/me`, data),

  changePassword: (data: { currentPassword: string; newPassword: string }) =>
    apiPost<{ message: string }>(`${BASE}/change-password`, data),

  forgotPassword: (email: string) =>
    apiPost<{ message: string }>(`${BASE}/forgot-password`, { email }),

  resetPassword: (token: string, password: string) =>
    apiPost<{ message: string }>(`${BASE}/reset-password`, { token, password }),
};
